"use strict";

var loginWidget = function () {
  var loginWidgetParams = {
    model: {},
    url: {},
    template: {}
  };

  function hideUserPopup(e) {
    var $popup = $('#userProfileLink > .popup');
    var $popupBtn = $('#userProfileLink');

    if (!$popup.is(e.target) && $popup.has(e.target).length === 0 && !$popupBtn.is(e.target) && $popupBtn.has(e.target).length === 0) {
      $popupBtn.removeClass('-open-menu');
    }
  }

  function unbindHandlers() {
    $(document).off('click', '#userProfileLink');
    $(document).off('click', '#logOutBtn');
    $(document).off('mouseup', hideUserPopup);
  }

  function bindHandlers() {
    $(document).on('click', '#userProfileLink', function () {
      $(this).toggleClass('-open-menu');
    });
    $(document).on('click', '#logOutBtn', function () {
      window.location = loginWidgetParams.url.logout;
    });
    $(document).on('mouseup', hideUserPopup);
  }

  function setParams(loginParams) {
    loginWidgetParams = $.extend({}, loginWidgetParams, loginParams);
  }

  function init(loginParams) {
    unbindHandlers();
    setParams(loginParams);
    bindHandlers();
  }

  return {
    init: init
  };
}();